'use client'

import { getCookie, setCookie } from 'cookies-next';
import { cookieDomain, cookieSameSite, cookieSecure } from 'lib/utils';
import { useRef } from 'react';
import { v4 as uuid4 } from 'uuid';

export default function useSessionId() {
  const sessionId = useRef<string>();
  if (typeof window === 'undefined') return '';

  sessionId.current = getCookie('sessionId')?.toString();
  if (!sessionId.current) {
    console.debug('No session Id found.  Setting a session Id client-side.');
    sessionId.current = uuid4();
    const secure = cookieSecure(process.env.AUTH_URL);
    const domain = cookieDomain(process.env.AUTH_URL);
    const sameSite = cookieSameSite(process.env.AUTH_URL, secure);
    setCookie('sessionId', sessionId.current, {
      domain,
      sameSite,
      path: "/",
      secure
    });
  }

  return sessionId.current ?? '';
}
